export default __webpack_public_path__ + "static/387-14898e77d97ac8003539f475b18d4d88.gif";